// extracted by mini-css-extract-plugin
module.exports = {"header":"title_header__2krsh","title_content":"title_title_content__86stL","title":"title_title__3g7RT","info":"title_info__6ZIzX"};